'use strict';

exports.__esModule = true;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.lookup = lookup;
exports.add = add;
exports.create = create;
exports.get = get;
exports.getById = getById;
exports.update = update;
exports.estimate = estimate;
exports.clone = clone;
exports.getByWhat3Words = getByWhat3Words;

var _http = require('../network/http');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  CUSTOMER_LOCATIONS_LOOKUP: '/customer/locations/search',
  CUSTOMER_LOCATIONS: '/customer/locations'
};

var locations = {
  lookup: lookup,
  add: add,
  create: create,
  get: get,
  getById: getById,
  estimate: estimate,
  update: update,
  clone: clone,
  getByWhat3Words: getByWhat3Words
};

exports.default = locations;

/**
 * Wrapper for `/customer/locations` API endpoint
 */

/**
 * Get all locations by filter
 * @param {string} postcode - postcode of the supported area
 * @param {string} locationId - id of the user location
 * @returns {promise} containing the entity array of locations
 */

function lookup(postcode, locationId) {
  return (0, _http.get)(API.CUSTOMER_LOCATIONS_LOOKUP, { locationId: locationId, query: postcode });
}

/**
 * Add new address
 * @param {string} [name] - display name for address, set as null to not associate with favourites
 * @param {string} address1 - house name or number
 * @param {string} [address2] - street name
 * @param {string} town - town name
 * @param {string} [county] - county name
 * @param {string} postcode - postcode of the supported area
 * @param {string} [contactName] - name of person at address
 * @param {string} [phone] - phone number at address
 * @returns {promise} containing the entity object of the location
 */
function add(name, address1, address2, town, county, postcode, contactName, phone) {
  return (0, _http.post)(API.CUSTOMER_LOCATIONS, { name: name, address1: address1, address2: address2, town: town, county: county, postcode: postcode, contactName: contactName, phone: phone });
}

/**
 * Create new address
 * @param {Object} [attributes] - attributes
 * @param {string} attributes.address1 - house name or number
 * @param {string} attributes.town - town name
 * @param {string} attributes.postcode - postcode of the supported area
 * @returns {promise} containing the entity object of the location
 */
function create(attributes) {
  return (0, _http.post)(API.CUSTOMER_LOCATIONS, attributes);
}

/**
 * Get all locations associated with customer
 * @returns {promise} containing the entity array of locations
 */
function get(params) {
  return (0, _http.get)(API.CUSTOMER_LOCATIONS, params);
}

/**
 * Get one location by ID
 * @returns {promise} resolves the location related to the ID
 */
function getById(locationId) {
  return (0, _http.get)(API.CUSTOMER_LOCATIONS + '/' + locationId);
}

/**
 * Update an existing address
 * @param {Sting|Number} id
 * @param {Object} data
 * @returns {promise} containing the updated location entity
 */
function update(id, data) {
  return (0, _http.put)(API.CUSTOMER_LOCATIONS + '/' + id, data);
}

/**
 * Get an distance and cost estimations based on 2 location ids
 * @param {string} [startLocationId] - the location id to start the path from
 * @param {string} [endLocationId] - the location id to end the path from
 * @returns {promise} containing the estimation
 */
function estimate(startLocationId, endLocationId) {
  return (0, _http.get)('/customer/locations/estimate?start_location_id=' + startLocationId + '&end_location_id=' + endLocationId);
}

function clone(_ref) {
  var locationId = _ref.locationId,
      payload = (0, _objectWithoutProperties3.default)(_ref, ['locationId']);

  return (0, _http.post)(API.CUSTOMER_LOCATIONS + '?lookup=' + locationId, payload);
}

function getByWhat3Words(wordsStr) {
  return (0, _http.get)(API.CUSTOMER_LOCATIONS + '/resolve?what3words=' + wordsStr);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/customer/locations.js
// module id = 1090
// module chunks = 0